(() => {

  'use strict';

  const config = JSON.parse(document.getElementById('MWConfig')?.textContent || '{}');

  const isClothing = p => p.tags?.includes('MW-CLOTHING') && ['Sweater','Cardigan','Coat','Set','Jacket','Pants','Vest','Blazer','Hoodie','Top','Skirt','Maxi Dress','Bathrobe'].includes(p.type);
  const scopedSearch = q => `(${q.trim().split(/\s+/u).map(word => 'title:' + word.replace(/[\\:*()"]/g,'') + '*').join(' AND ')}) AND tag:MW-CLOTHING`;

  const root = (config.root || '/').replace(/\/?$/, '/');
  const $ = (s, scope = document) => scope.querySelector(s);

  const $$ = (s, scope = document) => [...scope.querySelectorAll(s)];

  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  const money = cents => new Intl.NumberFormat(config.locale || 'en', {style:'currency',currency:config.currency || 'USD'}).format(cents / 100);

  let cartQueue = Promise.resolve(), quickSequence = 0;

  const productCache = new Map();

  const fetchJSON = async (url, options = {}) => {

    const response = await fetch(url, {credentials:'same-origin', ...options});

    const data = await response.json();

    if (!response.ok) throw new Error(data.description || data.message || 'Unable to complete this action. Please try again.');

    return data;

  };

  const getProduct = async handle => {

    if (!productCache.has(handle)) productCache.set(handle, fetchJSON(`${root}products/${encodeURIComponent(handle)}.js`).catch(error => {productCache.delete(handle);throw error;}));

    return productCache.get(handle);

  };

  function toast(message) {

    const el = $('.mw-toast'); if (!el) return;

    el.textContent = message; el.hidden = false;

    clearTimeout(el.timer); el.timer = setTimeout(() => {el.hidden = true;}, 3500);

  }

  function openDialog(dialog, trigger) {
    if (!dialog) return;
    if(dialog.mwFinishClose){dialog.mwFinishClose(false);}
    dialog.classList.remove('is-closing');
    dialog.returnFocus = trigger || document.activeElement;
    if (!dialog.open) dialog.showModal();

    document.documentElement.style.overflow = 'hidden';
    if(dialog.id==='MWCart')requestAnimationFrame(()=>setupCartRecommendations(dialog));

    setTimeout(() => {if(dialog.open&&!dialog.classList.contains('is-closing'))$('input:not([type=hidden]),button,summary,a',dialog)?.focus({preventScroll:true});}, 0);
  }
  function closeDialog(dialog) {
    if(!dialog?.open)return Promise.resolve();
    if(dialog.mwClosePromise)return dialog.mwClosePromise;
    if(!dialog.matches('.mw-quick-drawer,.mw-cart-drawer,.mw-fit-modal,.mw-size-modal,.mw-zoom')||matchMedia('(prefers-reduced-motion:reduce)').matches){dialog.close();return Promise.resolve();}
    dialog.classList.add('is-closing');
    dialog.mwClosePromise=new Promise(resolve=>{
      const exitAnimation=dialog.classList.contains('mw-zoom')?'mw-zoom-fade-out':dialog.classList.contains('mw-size-modal')?'mw-size-fade-out':dialog.classList.contains('mw-fit-modal')?'mw-fit-fade-out':dialog.classList.contains('mw-quick-drawer')?'mw-quick-fade-out':'mw-quick-exit';
      const onEnd=event=>{if(event.target===dialog&&event.animationName===exitAnimation)finish(true);};
      const finish=close=>{
        clearTimeout(dialog.mwCloseTimer);dialog.removeEventListener('animationend',onEnd);
        dialog.mwFinishClose=null;dialog.mwClosePromise=null;
        if(close&&dialog.open)dialog.close();
        dialog.classList.remove('is-closing');resolve();
      };
      dialog.mwFinishClose=finish;dialog.addEventListener('animationend',onEnd);
      dialog.mwCloseTimer=setTimeout(()=>finish(true),320);
    });
    return dialog.mwClosePromise;
  }

  async function refreshCart(data) {

    if (!data || typeof data.item_count !== 'number') data = await fetchJSON(`${root}cart.js`);

    $$('[data-cart-count]').forEach(el => {el.textContent=data.item_count;el.hidden=data.item_count===0;});
    $$('[data-cart-total-count]').forEach(el => {el.textContent=data.item_count;});
    const response = await fetch(`${root}?section_id=mw-cart-render`,{credentials:'same-origin',cache:'no-store'});

    if (!response.ok) throw new Error('Your bag updated, but could not be displayed. Open the bag page to view it.');

    const html = new DOMParser().parseFromString(await response.text(),'text/html');

    const next = $('[data-cart-content=drawer]',html);

    if (!next) throw new Error('Please refresh to view your updated bag.');

    $$('[data-cart-content]').forEach(el => {
      const replacement=$(`[data-cart-content="${el.dataset.cartContent}"]`,html);
      if(replacement){const scroll=$('.mw-cart-scroll',el)?.scrollTop||0;el.replaceWith(replacement.cloneNode(true));const nextScroll=$('#MWCart .mw-cart-scroll');if(nextScroll)nextScroll.scrollTop=scroll;}
    });
    setupCartRecommendations($('#MWCart'));
    window.Shopify?.PaymentButton?.init?.();

    return data;

  }

  function mutateCart(action) {
    cartQueue = cartQueue.catch(() => {}).then(action);

    return cartQueue;
  }
  function setupCartRecommendations(scope=document) {
    $$('[data-cart-recommendations]',scope).forEach(section => {
      if(section.mwCarouselBound){section.mwCarouselUpdate?.();return;}
      section.mwCarouselBound=true;
      const track=$('.mw-cart-recommendations-track',section);
      const previous=$('[data-cart-slide="-1"]',section),next=$('[data-cart-slide="1"]',section);
      const update=()=>{
        const end=Math.max(0,track.scrollWidth-track.clientWidth);
        if(previous)previous.disabled=track.scrollLeft<=1;
        if(next)next.disabled=track.scrollLeft>=end-1;
      };
      section.mwCarouselUpdate=update;
      $$('[data-cart-slide]',section).forEach(button=>button.addEventListener('click',()=>{
        const card=$('.mw-cart-upsell',track);
        const step=card ? card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0) : track.clientWidth;
        track.scrollBy({left:step*Number(button.dataset.cartSlide),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      }));
      track.addEventListener('scroll',()=>requestAnimationFrame(update),{passive:true});
      let drag=null,suppressClick=false;
      track.addEventListener('dragstart',event=>event.preventDefault());
      track.addEventListener('pointerdown',event=>{
        if(event.pointerType!=='mouse'||event.button!==0||event.target.closest('button'))return;
        drag={x:event.clientX,left:track.scrollLeft,moved:false};
      });
      track.addEventListener('pointermove',event=>{
        if(!drag)return;
        if(!(event.buttons&1)){drag=null;track.classList.remove('is-dragging');return;}
        if(Math.abs(event.clientX-drag.x)>5){
          if(!drag.moved){drag.moved=true;track.setPointerCapture(event.pointerId);track.classList.add('is-dragging');}
          track.scrollLeft=drag.left-(event.clientX-drag.x);
          event.preventDefault();
        }
      });
      const finish=()=>{
        if(drag?.moved){suppressClick=true;setTimeout(()=>{suppressClick=false;},0);}
        drag=null;track.classList.remove('is-dragging');update();
      };
      track.addEventListener('pointerup',finish);
      track.addEventListener('pointercancel',finish);
      track.addEventListener('click',event=>{if(suppressClick){event.preventDefault();event.stopPropagation();suppressClick=false;}},true);
      update();
    });
  }
  function setupPdpSuggestions(scope=document) {
    $$('[data-pdp-suggestions]',scope).forEach(section=>{
      if(section.mwSuggestionsBound){section.mwSuggestionsUpdate?.();return;}
      section.mwSuggestionsBound=true;
      const rail=$('.mw-pdp-suggestion-rail',section);
      const previous=$('[data-pdp-suggestion-step="-1"]',section),next=$('[data-pdp-suggestion-step="1"]',section);
      const update=()=>{
        const end=Math.max(0,rail.scrollWidth-rail.clientWidth);
        previous.disabled=rail.scrollLeft<=1;
        next.disabled=rail.scrollLeft>=end-1;
      };
      section.mwSuggestionsUpdate=update;
      $$('[data-pdp-suggestion-step]',section).forEach(button=>button.addEventListener('click',()=>{
        const card=$('.mw-pdp-suggestion',rail);
        const step=card?card.getBoundingClientRect().width+(parseFloat(getComputedStyle(rail).gap)||0):rail.clientWidth;
        rail.scrollBy({left:step*Number(button.dataset.pdpSuggestionStep),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      }));
      rail.addEventListener('scroll',update,{passive:true});
      if(window.ResizeObserver){section.mwSuggestionsObserver=new ResizeObserver(update);section.mwSuggestionsObserver.observe(rail);}
      update();
    });
  }
  async function updateCartQuantity(input) {
    clearTimeout(input.mwQuantityTimer);
    if(input.disabled || !input.isConnected || input.value.trim()==='')return;
    const quantity=Math.max(0,Math.min(99,Math.floor(Number(input.value)||0)));
    if(quantity===Number(input.defaultValue))return;
    input.disabled=true;
    const checkoutButtons=$$('[name=checkout]');checkoutButtons.forEach(b=>b.disabled=true);
    try {
      await mutateCart(async()=>refreshCart(await fetchJSON(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:input.dataset.cartKey,quantity})})));
    } catch(e) {
      input.value=input.defaultValue;input.disabled=false;toast(e.message);
      // Shopify may cap the cart quantity while returning an inventory error.
      // Reload the persisted cart so the amount never disagrees with checkout.
      await refreshCart().catch(()=>{});
      $$('[data-cart-error]').forEach(message=>message.textContent=e.message);
    } finally {checkoutButtons.forEach(b=>b.disabled=false);}
  }
  async function addProduct(form,trigger) {

    const button = $('button[type=submit]',form), error = $('[data-form-error]',form) || $('[data-form-error]',form.parentElement);

    if (button?.disabled) return;

    const oldLabel = button?.textContent;

    if (button) {button.disabled=true;button.textContent='Adding…';}

    if (error) error.textContent='';

    let added = false;

    try {

      await mutateCart(async () => {

        await fetchJSON(`${root}cart/add.js`,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});

        added=true;

        await refreshCart();
        await closeDialog($('#MWQuick'));
        openDialog($('#MWCart'),trigger||button);

      });

    } catch (e) {

      const message = added ? 'Added to your bag. Please open the shopping bag page to view the latest contents.' : e.message;

      if (error) error.textContent=message;

      toast(message);

    } finally {if(button){button.disabled=false;button.textContent=oldLabel;}}

  }


  // Shared verified color/media policy; no color is inferred from a filename or option order.
  function colorMediaGroup(scope,variant){
    const node=$('[data-color-media]',scope);if(!node)return null;
    const groups=JSON.parse(node.textContent).groups||[];
    return groups.find(group=>variant?.options?.includes(group.name))||null;
  }
  function applyColorGallery(scope,variant,quick=false){
    const group=colorMediaGroup(scope,variant);if(!group)return;
    if(scope.mwColorGroup===group.name)return;scope.mwColorGroup=group.name;
    const gallery=$(quick?'[data-quick-gallery]':'[data-gallery]',scope);if(!gallery)return;
    const ids=new Set(group.image_ids.map(String));
    Array.from(gallery.children).forEach(slide=>{slide.hidden=!ids.has(String(quick?slide.dataset.quickImageId:(slide.dataset.imageId||slide.dataset.mediaId)));});
    gallery.scrollLeft=0;
    if(quick){if(scope.mwQuickGalleryRefresh)scope.mwQuickGalleryRefresh();else initQuickGallery(scope);}
    else{
      // Keep the server-rendered gallery layout stable across color selections.
      gallery.mwGalleryCleanup?.();delete gallery.dataset.mwBound;setupProductGallery(scope);
    }
  }
  function initializeColorMedia(scope){
    $$('[data-product-section]',scope).forEach(section=>{
      if(section.dataset.colorMediaBound)return;section.dataset.colorMediaBound='true';
      updateVariant(section);
    });
  }

  function updateVariant(section) {
    const data=JSON.parse($('[data-product-json]',section).textContent),selected=[];
    const fields=$$('[data-option-index]',section);
    fields.forEach(field=>selected[Number(field.dataset.optionIndex)]=$('input:checked',field)?.value);
    const variant=data.variants.find(v=>v.options.every((value,i)=>value===selected[i]));
    const form=$('.mw-product-form',section),button=$('[data-add-button]',section);if(!form||!button)return;
    const id=$('[name=id]',form);id.value=variant?.id||'';id.dispatchEvent(new Event('change',{bubbles:true}));
    button.disabled=!variant?.available;button.textContent=variant?.available?(section.dataset.addLabel||config.addLabel):(variant?(section.dataset.soldLabel||config.soldLabel):'Unavailable');
    const payment=$('[data-pdp-payment]',form);if(payment)payment.hidden=!variant?.available;
    const stock=$('[data-stock-note]',section),inventory=JSON.parse($('[data-product-inventory]',section)?.textContent||'{}')[variant?.id];
    if(stock)stock.textContent=variant?.available&&inventory?.tracked&&!inventory.continue&&inventory.quantity>0&&inventory.quantity<6?`◷  Only ${inventory.quantity} left in stock. Order soon.`:'';
    fields.forEach(field=>{
      const index=Number(field.dataset.optionIndex);$('[data-selected-option]',field).textContent=selected[index]||'';
      $$('input',field).forEach(input=>{
        const available=data.variants.some(v=>v.available&&v.options[index]===input.value&&(field.classList.contains('mw-option-color')||v.options.every((value,i)=>i===index||value===selected[i])));
        input.closest('label').classList.toggle('is-unavailable',!available);
      });
    });
    if(variant){
      $('[data-variant-price]',section).innerHTML=money(variant.price)+(variant.compare_at_price>variant.price?` <s>${money(variant.compare_at_price)}</s>`:'');
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      const gallery=$('[data-gallery]',section),imageId=variant.featured_media?.id||variant.featured_image?.id;
      const slide=imageId&&$(`[data-media-id="${imageId}"]`,gallery);
      if(slide&&getComputedStyle(gallery).display!=='grid')gallery.scrollTo({left:slide.offsetLeft-gallery.offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }
    applyColorGallery(section,variant);
    syncStickyPurchase(section,variant);
  }
  function syncStickyPurchase(section,variant) {
    const bar=$('[data-sticky-purchase]',section);if(!bar)return;
    const primary=$('[data-add-button]',section),button=$('[data-sticky-add]',bar);
    if(primary){button.disabled=primary.disabled;button.textContent=primary.textContent;}
    if(variant){
      $('[data-sticky-price]',bar).innerHTML=money(variant.price)+(variant.compare_at_price>variant.price?` <s>${money(variant.compare_at_price)}</s>`:'');
      $$('[data-sticky-option]',bar).forEach(el=>el.textContent=variant.options[Number(el.dataset.stickyOption)]||'');
      const image=$('img',bar),source=variant.featured_image?.src||JSON.parse($('[data-product-json]',section).textContent).featured_image;
      if(image&&source){image.removeAttribute('srcset');image.src=source;}
    }
  }
  function setupStickyPurchase(scope=document) {
    $$('[data-product-section]',scope).forEach(section=>{
      const bar=$('[data-sticky-purchase]',section),row=$('.mw-buy-row',section),primary=$('[data-add-button]',section),header=$('.mw-header');
      if(!bar||!row||!primary||bar.dataset.mwBound)return;bar.dataset.mwBound='true';
      let frame=null;
      const update=()=>{frame=null;const top=Math.max(0,header?.getBoundingClientRect().bottom||0);bar.style.top=`${top}px`;bar.hidden=row.getBoundingClientRect().bottom>top;};
      const schedule=()=>{if(frame===null)frame=requestAnimationFrame(update);};
      const buttonObserver=new MutationObserver(()=>syncStickyPurchase(section));
      buttonObserver.observe(primary,{attributes:true,attributeFilter:['disabled'],childList:true,subtree:true,characterData:true});
      const resizeObserver=new ResizeObserver(schedule);resizeObserver.observe(row);if(header)resizeObserver.observe(header);
      addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);
      section.mwStickyCleanup=()=>{removeEventListener('scroll',schedule);removeEventListener('resize',schedule);buttonObserver.disconnect();resizeObserver.disconnect();if(frame!==null)cancelAnimationFrame(frame);};
      syncStickyPurchase(section);update();
    });
  }
  function setupProductGallery(scope){
    $$('[data-gallery]',scope).forEach(gallery=>{
      if(gallery.dataset.mwBound)return;gallery.dataset.mwBound='true';
      const wrapper=gallery.closest('.mw-gallery-wrap'),slides=Array.from(gallery.children).filter(slide=>!slide.hidden);
      const section=gallery.closest('[data-product-section]'),info=section&&$('.mw-product-info',section),header=$('.mw-header');
      const stickyGallery=gallery.dataset.galleryLayout==='grid';
      let frame=null;
      const schedule=()=>{if(frame===null)frame=requestAnimationFrame(()=>{frame=null;sync();});};
      const sync=()=>{
        const grid=getComputedStyle(gallery).display==='grid';
        if(stickyGallery&&info){
          if(grid){
            const headerBottom=Math.max(0,header?.getBoundingClientRect().bottom||0);
            const top=Math.floor(Math.min(headerBottom+16,innerHeight-info.getBoundingClientRect().height-16));
            const value=`${top}px`;
            if(section.style.getPropertyValue('--mw-pdp-info-top')!==value)section.style.setProperty('--mw-pdp-info-top',value);
          }else section.style.removeProperty('--mw-pdp-info-top');
        }
        const index=grid?0:Math.round(gallery.scrollLeft/Math.max(1,gallery.clientWidth));
        const prev=$('[data-gallery-step="-1"]',wrapper),next=$('[data-gallery-step="1"]',wrapper);
        if(prev)prev.hidden=grid||index===0;if(next)next.hidden=grid||index>=slides.length-1;
        const zoom=$('[data-gallery-zoom]',wrapper);if(zoom)zoom.hidden=grid||!slides[index]?.hasAttribute('data-zoom');
        const status=$('[data-gallery-status]',wrapper);if(status)status.textContent=grid?`${slides.length} product views`:`Image ${index+1} of ${slides.length}`;
      };
      gallery.addEventListener('scroll',sync,{passive:true});
      const resize=new ResizeObserver(schedule);resize.observe(gallery);
      if(stickyGallery&&info){
        resize.observe(info);if(header)resize.observe(header);
        addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);
      }
      gallery.mwGalleryCleanup=()=>{
        resize.disconnect();gallery.removeEventListener('scroll',sync);
        removeEventListener('scroll',schedule);removeEventListener('resize',schedule);
        if(frame!==null)cancelAnimationFrame(frame);
      };
      sync();
    });
  }
  function renderImageZoom() {
    const dialog=$('#MWZoom'),slides=dialog?.mwZoomSlides;
    if(!slides?.length)return;
    const slide=slides[dialog.mwZoomIndex],source=$('img',slide),image=$('[data-zoom-image]',dialog);
    image.src=slide.dataset.zoom;image.alt=source?.alt||'Product detail';
    image.width=Number(source?.getAttribute('width'))||1200;image.height=Number(source?.getAttribute('height'))||1600;
    $('.mw-zoom-frame',dialog).style.aspectRatio=`${image.width} / ${image.height}`;
    $('[data-zoom-step="-1"]',dialog).disabled=dialog.mwZoomIndex===0;
    $('[data-zoom-step="1"]',dialog).disabled=dialog.mwZoomIndex===slides.length-1;
    $('[data-zoom-status]',dialog).textContent=`Image ${dialog.mwZoomIndex+1} of ${slides.length}`;
  }
  function openImageZoom(slide,trigger) {
    const dialog=$('#MWZoom');if(!dialog||!slide?.dataset.zoom)return;
    dialog.mwZoomSlides=$$('[data-zoom]',slide.closest('[data-gallery]')||slide.parentElement).filter(item=>!item.hidden);
    dialog.mwZoomIndex=Math.max(0,dialog.mwZoomSlides.indexOf(slide));
    renderImageZoom();openDialog(dialog,trigger);
  }
  function stepImageZoom(step) {
    const dialog=$('#MWZoom');if(!dialog?.open||!dialog.mwZoomSlides?.length)return;
    dialog.mwZoomIndex=Math.max(0,Math.min(dialog.mwZoomSlides.length-1,dialog.mwZoomIndex+step));renderImageZoom();
  }

  function initQuickGallery(box){
    const track=$('[data-quick-gallery]',box);if(!track)return;
    let slides=$$('.mw-quick-slide',track).filter(slide=>!slide.hidden),previous=$('[data-quick-slide="-1"]',box),next=$('[data-quick-slide="1"]',box),status=$('[data-quick-image-status]',box);
    $$('img',track).forEach(image=>{
      const retry=()=>{
        if(image.dataset.quickImageRetried)return;
        image.dataset.quickImageRetried='true';
        const source=new URL(image.src,location.href);source.searchParams.set('_mw_image_retry','1');
        image.removeAttribute('srcset');image.src=source.href;
      };
      image.addEventListener('error',retry,{once:true});
      if(image.currentSrc&&image.complete&&!image.naturalWidth)retry();
    });
    let targetIndex=0,frame=0;
    const step=()=>slides[0]?.getBoundingClientRect().width+8||track.clientWidth;
    const last=()=>Math.max(0,slides.length-2);
    const update=()=>{
      const index=Math.max(0,Math.min(last(),Math.round(track.scrollLeft/step())));
      if(previous)previous.disabled=index===0;
      if(next)next.disabled=index===last();
      if(status)status.textContent=slides.length>1?`Images ${index+1}–${Math.min(index+2,slides.length)} of ${slides.length}`:'Image 1 of 1';
    };
    box.mwQuickGalleryGoTo=(index,behavior='auto')=>{
      targetIndex=Math.max(0,Math.min(last(),index));
      track.scrollTo({left:targetIndex*step(),behavior});
      update();
    };
    box.mwQuickGalleryRefresh=()=>{slides=$$('.mw-quick-slide',track).filter(slide=>!slide.hidden);targetIndex=0;box.mwQuickGalleryGoTo(0);};
    const move=direction=>box.mwQuickGalleryGoTo(targetIndex+direction,matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth');
    $$('[data-quick-slide]',box).forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.quickSlide))));
    track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});
    track.addEventListener('scrollend',()=>{targetIndex=Math.max(0,Math.min(last(),Math.round(track.scrollLeft/step())));});
    track.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}
    });
    const resize=new ResizeObserver(()=>box.mwQuickGalleryGoTo(targetIndex));resize.observe(track);
    box.mwQuickGalleryCleanup=()=>{resize.disconnect();cancelAnimationFrame(frame);delete box.mwQuickGalleryGoTo;delete box.mwQuickVariantImage;delete box.mwQuickGalleryRefresh;};
    update();
  }

  async function quickShop(handle,trigger) {

    const sequence=++quickSequence,dialog=$('#MWQuick'),box=$('[data-quick-content]',dialog);

    box.mwQuickGalleryCleanup?.();box.setAttribute('aria-busy','true');
    box.innerHTML='<div class="mw-quick-skeleton" aria-hidden="true"><div class="mw-quick-gallery"><div></div><div></div></div><div class="mw-skeleton-line"></div><div class="mw-skeleton-line mw-skeleton-short"></div><div class="mw-skeleton-options"></div></div><span class="visually-hidden" role="status">Loading product options</span>';
    openDialog(dialog,trigger);
    try {

      const p=await getProduct(handle);if(sequence!==quickSequence)return;

      const variant=p.variants.find(v=>v.available)||p.variants[0];

      const response=await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=mw-quick-product&variant=${variant.id}`,{credentials:'same-origin'});
      if(!response.ok)throw new Error('Unable to load product options. Please try again.');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html'),content=$('[data-quick-product]',doc);
      if(sequence!==quickSequence)return;
      if(!content)throw new Error('Unable to load product options. Please open the product page.');
      box.replaceChildren(content);box.removeAttribute('aria-busy');box.product=JSON.parse($('[data-product-json]',box).textContent);initQuickGallery(box);updateQuickVariant(box);
      window.Shopify?.PaymentButton?.init?.();
    } catch(e){if(sequence===quickSequence){box.removeAttribute('aria-busy');box.textContent=e.message;}}
  }
  function updateQuickVariant(box){
    const p=box.product,fields=$$('[data-quick-option-index]',box),selected=[];
    fields.forEach(field=>{selected[Number(field.dataset.quickOptionIndex)]=$('input:checked',field)?.value;});
    const variant=p.variants.find(v=>v.options.every((value,i)=>value===selected[i]));
    const form=$('[data-quick-form]',box),button=$('.mw-quick-add',form),id=$('[name=id]',form);
    id.value=variant?.id||'';id.dispatchEvent(new Event('change',{bubbles:true}));
    button.disabled=!variant?.available;button.textContent=variant?.available?config.quickAddLabel:(variant?config.soldLabel:'Unavailable');
    $('[data-quick-payment]',box).hidden=!variant?.available;
    fields.forEach(field=>{
      const index=Number(field.dataset.quickOptionIndex);$('[data-quick-selected]',field).textContent=selected[index]||'';
      $$('[data-quick-option]',field).forEach(input=>{
        const color=field.classList.contains('mw-quick-color');
        const available=p.variants.some(v=>v.available&&v.options[index]===input.value&&(color||v.options.every((value,i)=>i===index||value===selected[i])));
        input.disabled=!available&&!input.checked;input.closest('label').classList.toggle('is-unavailable',!available);
      });
    });
    if(variant){
      applyColorGallery(box,variant,true);
      $('[data-quick-price]',box).innerHTML=money(variant.price)+(variant.compare_at_price>variant.price?` <s>${money(variant.compare_at_price)}</s>`:'');
      $('[data-quick-detail]',box).href=`${root}products/${encodeURIComponent(p.handle)}?variant=${variant.id}`;
      const imageKey=String(variant.featured_image?.id||variant.featured_image?.src||'');
      if(box.mwQuickVariantImage!==undefined&&box.mwQuickVariantImage!==imageKey&&variant.featured_image){
        const slides=$$('.mw-quick-slide',box).filter(slide=>!slide.hidden),index=slides.findIndex(slide=>slide.dataset.quickImageId===String(variant.featured_image.id));
        if(index>=0)box.mwQuickGalleryGoTo?.(index);
      }
      box.mwQuickVariantImage=imageKey;
    }
  }
  const wishlistKey='mw-wishlist-v1';

  function wishList(){try{return JSON.parse(localStorage.getItem(wishlistKey)||'[]');}catch{return [];}}

  function syncWish(){const list=wishList();$$('[data-wishlist]').forEach(b=>b.setAttribute('aria-pressed',String(list.includes(b.dataset.wishlist))));}

  async function renderWishlist() {

    const grid=$('[data-wishlist-grid]');if(!grid)return;

    const handles=wishList();grid.replaceChildren();const empty=$('[data-wishlist-empty]');if(empty)empty.hidden=handles.length>0;

    const records=await Promise.allSettled(handles.map(getProduct));

    records.forEach((result,i)=>{

      if(result.status!=='fulfilled')return;

      const p=result.value;if(!isClothing(p))return;const card=document.createElement('article');card.className='mw-card';

      card.innerHTML=`<a class="mw-card-images" href="${root}products/${encodeURIComponent(p.handle)}"><img src="${escape(p.featured_image)}" loading="lazy" alt="${escape(p.title)}"></a><div class="mw-card-body"><h3><a href="${root}products/${encodeURIComponent(p.handle)}">${escape(p.title)}</a></h3><p>${money(p.price)}</p><button class="mw-pill" data-quick="${escape(p.handle)}">Choose options</button> <button class="mw-text-link" data-wishlist="${escape(p.handle)}" aria-pressed="true">Remove</button></div>`;grid.append(card);

    });
    if(empty)empty.hidden=grid.children.length>0;

  }

  function renderBundle(section) {

    const items=section.bundleItems||[],count=items.length,subtotal=items.reduce((sum,p)=>sum+p.price,0);

    const tiers=$$('[data-tier-qty]',section).sort((a,b)=>Number(a.dataset.tierQty)-Number(b.dataset.tierQty));

    const matched=tiers.filter(t=>count>=Number(t.dataset.tierQty)),pct=Number(matched.at(-1)?.dataset.tierPct||0),next=tiers.find(t=>count<Number(t.dataset.tierQty));

    tiers.forEach(t=>{t.classList.toggle('is-unlocked',count>=Number(t.dataset.tierQty));t.classList.toggle('is-current',t===matched.at(-1));});

    $('[data-bundle-count]',section).textContent=count;
    const progress=$('[data-bundle-progress]',section),lastThreshold=Number(tiers.at(-1)?.dataset.tierQty||section.dataset.maxItems);
    if(progress){progress.setAttribute('aria-valuenow',count);$('span',progress).style.width=`${Math.min(100,count/lastThreshold*100)}%`;}
    const empty=$('[data-bundle-empty]',section);if(empty)empty.hidden=count>0;
    $$('[data-bundle-product]',section).forEach(card=>{
      const added=$('[data-bundle-added]',card),quantity=items.filter(p=>String(p.productId)===card.dataset.bundleProductId).length;
      if(added){added.textContent=`${quantity} added`;added.hidden=quantity===0;}
      const select=$('[data-bundle-variant]',card),option=select.selectedOptions[0];
      select.disabled=!!section.bundleBusy;
      $('[data-bundle-add]',card).disabled=!!section.bundleBusy||count>=Number(section.dataset.maxItems)||!option?.value||option.disabled||items.filter(p=>p.id===Number(option.value)).length>=Number(option.dataset.stock||section.dataset.maxItems);
    });

    $('[data-bundle-items]',section).innerHTML=items.map((p,i)=>`<div class="mw-bundle-item"><img src="${escape(p.image)}" alt="${escape(p.title)}"><div><a href="${escape(p.url)}">${escape(p.title)}</a><small>${escape(p.variant)}</small><strong>${money(p.price)}</strong><button class="mw-text-link" type="button" data-bundle-remove="${i}">Remove</button></div></div>`).join('');

    const savings=items.reduce((sum,p)=>sum+Math.round(p.price*pct/100),0);

    $('[data-bundle-subtotal]',section).textContent=money(subtotal);$('[data-bundle-savings]',section).textContent=money(savings);$('[data-bundle-total]',section).textContent=money(subtotal-savings);

    $('[data-bundle-status]',section).textContent=next?`${pct?`${pct}% savings unlocked. `:''}Add ${Number(next.dataset.tierQty)-count} more ${Number(next.dataset.tierQty)-count===1?'piece':'pieces'} to save ${next.dataset.tierPct}%.`:`${pct}% savings unlocked${count>=Number(section.dataset.maxItems)?' — your bundle is full.':'.'}`;
    const mobileTotal=$('[data-bundle-mobile-total]',section),mobileCount=$('[data-bundle-mobile-count]',section);
    if(mobileTotal)mobileTotal.textContent=money(subtotal-savings);if(mobileCount)mobileCount.textContent=count;
    $$('[data-bundle-remove]',section).forEach(b=>{b.disabled=!!section.bundleBusy;b.setAttribute('aria-label',`Remove ${items[Number(b.dataset.bundleRemove)].title} from bundle`);});

    $('[data-bundle-submit]',section).disabled=count===0||!!section.bundleBusy;

  }

  function initialize(scope=document) {
    initializeColorMedia(scope);
    setupStickyPurchase(scope);
    setupPdpSuggestions(scope);
    setupCartRecommendations(scope);
    setupProductGallery(scope);

    $$('[data-bundle-section]',scope).forEach(section=>{if(!section.bundleItems){section.bundleItems=[];renderBundle(section);}});

    $$('dialog',scope).forEach(dialog=>{

      if(dialog.dataset.mwBound)return;dialog.dataset.mwBound='true';

      dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeDialog(dialog);}});

      dialog.addEventListener('cancel',event=>{if(dialog.matches('.mw-quick-drawer,.mw-cart-drawer,.mw-fit-modal,.mw-size-modal,.mw-zoom')){event.preventDefault();closeDialog(dialog);}});
      if(dialog.id==='MWZoom'){
        let start=null;
        const stage=$('[data-zoom-stage]',dialog);
        stage.addEventListener('touchstart',event=>{const touch=event.touches[0];start=event.touches.length===1?{x:touch.clientX,y:touch.clientY}:null;},{passive:true});
        stage.addEventListener('touchend',event=>{if(!start)return;const touch=event.changedTouches[0],dx=touch.clientX-start.x,dy=touch.clientY-start.y;start=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)stepImageZoom(dx<0?1:-1);},{passive:true});
      }
      dialog.addEventListener('close',()=>{
        if(!document.querySelector('dialog[open]')){document.documentElement.style.overflow='';dialog.returnFocus?.focus?.({preventScroll:true});}
        $$('video',dialog).forEach(v=>v.pause());

      });
    });

    $$('[data-announcements]',scope).forEach(el=>{

      if(el.mwTimer)return;const slides=$$('a',el);let index=0;

      if(slides.length>1)el.mwTimer=setInterval(()=>{slides[index].hidden=true;index=(index+1)%slides.length;slides[index].hidden=false;},Number(el.dataset.interval)||5000);

    });

    /* Desktop navigation: one hover region, buffered close and deliberate switching. */
    $$('.mw-desktop-nav',scope).forEach(nav=>{
      if(nav.dataset.mwNavBound)return;nav.dataset.mwNavBound='true';
      const header=nav.closest('.mw-header');if(!header)return;
      const items=$$('.mw-nav-details',nav),media=matchMedia('(min-width:990px) and (hover:hover) and (pointer:fine)');
      const remove=[];
      const listen=(node,type,handler,options)=>{node.addEventListener(type,handler,options);remove.push(()=>node.removeEventListener(type,handler,options));};
      let switchTimer,closeTimer,switchTarget=null,headerHovered=false,currentItem=null;
      const clearSwitch=()=>{clearTimeout(switchTimer);switchTarget=null;};
      const clearClose=()=>clearTimeout(closeTimer);
      const stopTimers=()=>{clearSwitch();clearClose();};
      const closeAll=()=>{stopTimers();currentItem=null;items.forEach(item=>item.open=false);};
      const show=item=>{stopTimers();currentItem=item;item.open=true;items.forEach(other=>{if(other!==item)other.open=false;});};
      const panelHasFocus=()=>items.some(item=>item.open&&$('.mw-mega',item)?.contains(document.activeElement));
      listen(header,'mouseenter',()=>{headerHovered=true;clearClose();});
      listen(header,'mouseleave',()=>{
        headerHovered=false;clearSwitch();
        if(!media.matches||panelHasFocus())return;
        clearClose();closeTimer=setTimeout(()=>{if(!headerHovered&&!panelHasFocus())closeAll();},320);
      });
      listen(header,'focusin',()=>stopTimers());
      listen(header,'focusout',event=>{if(!header.contains(event.relatedTarget))closeAll();});
      items.forEach(item=>{
        const summary=$('summary',item),panel=$('.mw-mega',item);
        listen(item,'mouseenter',()=>{
          if(!media.matches)return;
          clearClose();clearSwitch();
          if(item.open)return;
          if(!items.some(other=>other.open)){show(item);return;}
          switchTarget=item;
          switchTimer=setTimeout(()=>{if(switchTarget===item)show(item);},120);
        });
        listen(item,'mouseleave',()=>{if(switchTarget===item)clearSwitch();});
        if(panel)listen(panel,'mouseenter',()=>{if(item.open)stopTimers();});
        listen(summary,'click',event=>{
          if(event.detail>0&&event.pointerType!=='touch'&&media.matches){event.preventDefault();show(item);}
        });
        listen(summary,'keydown',event=>{
          if(event.key!=='ArrowDown')return;
          event.preventDefault();show(item);$('a[href],button',panel)?.focus();
        });
        listen(item,'toggle',()=>{
          if(!item.open){if(currentItem===item)currentItem=null;return;}
          if(currentItem!==item){stopTimers();currentItem=item;items.forEach(other=>{if(other!==item)other.open=false;});}
        });
      });
      $$('.mw-nav-item>a',nav).forEach(link=>{
        listen(link,'mouseenter',()=>{
          if(!media.matches)return;stopTimers();switchTarget=link;
          switchTimer=setTimeout(()=>{if(switchTarget===link)closeAll();},120);
        });
        listen(link,'mouseleave',()=>{if(switchTarget===link)clearSwitch();});
      });
      listen(document,'pointerdown',event=>{if(!header.contains(event.target))closeAll();});
      listen(document,'keydown',event=>{
        if(event.key!=='Escape')return;
        const active=items.find(item=>item.open);closeAll();
        if(active&&header.contains(event.target))$('summary',active)?.focus();
      },true);
      listen(media,'change',()=>closeAll());
      nav.mwNavCleanup=()=>{closeAll();remove.forEach(off=>off());delete nav.dataset.mwNavBound;delete nav.mwNavCleanup;};
    });
    /* End desktop navigation controller. */
    $$('.mw-footer-column',scope).forEach((el,i)=>{if(matchMedia('(max-width:749px)').matches)el.open=i===0;});

    $$('video[data-src-desktop]',scope).forEach(video=>{

      if(video.dataset.mwBound)return;video.dataset.mwBound='true';

      const container=video.parentElement,button=$('.ed-hero__video-toggle',container);

      const attach=()=>{const src=matchMedia('(max-width:749px)').matches?video.dataset.srcMobile:video.dataset.srcDesktop;if(src&&video.getAttribute('src')!==src)video.src=src;};

      const label=()=>{if(button){button.hidden=false;button.classList.toggle('is--paused',video.paused);button.setAttribute('aria-label',video.paused?'Play video':'Pause video');}};

      const play=()=>{attach();video.muted=true;video.play().catch(()=>{});};

      video.addEventListener('playing',()=>{video.style.opacity='1';label();});video.addEventListener('pause',label);

      button?.addEventListener('click',()=>{video.mwUserPaused=!video.paused;if(video.paused)play();else video.pause();});

      new IntersectionObserver(entries=>{if(entries[0].isIntersecting&&!video.mwUserPaused&&!matchMedia('(prefers-reduced-motion:reduce)').matches)play();else video.pause();},{threshold:.1}).observe(container);label();

    });

    syncWish();

  }

  document.addEventListener('click',async event=>{

    const el=event.target.closest('button,a,summary');if(!el)return;

    if(el.hasAttribute('data-open')){event.preventDefault();openDialog(document.getElementById(el.dataset.open),el);if(el.dataset.open==='MWCart')refreshCart().catch(e=>toast(e.message));}

    if(el.hasAttribute('data-close')){event.preventDefault();closeDialog(el.closest('dialog'));}

    if(el.hasAttribute('data-tab')){const section=el.closest('[data-product-tabs]');$$('[role=tab]',section).forEach(b=>b.setAttribute('aria-selected',String(b===el)));$$('[role=tabpanel]',section).forEach(p=>p.hidden=p.id!==el.dataset.tab);}

    if(el.hasAttribute('data-quick')){event.preventDefault();if(el.closest('#MWCart'))await closeDialog($('#MWCart'));quickShop(el.dataset.quick,el);}

    if(el.hasAttribute('data-wishlist')){

      event.preventDefault();let list=wishList();const handle=el.dataset.wishlist,adding=!list.includes(handle);list=adding?[...list,handle]:list.filter(h=>h!==handle);

      try{localStorage.setItem(wishlistKey,JSON.stringify(list));syncWish();toast(adding?'Saved to your wishlist':'Removed from your wishlist');renderWishlist();}catch{toast('Wishlist storage is unavailable in this browser.');}

    }

    if(el.hasAttribute('data-quantity-step')){const input=$('input',el.parentElement);input.value=Math.max(1,Math.min(99,(Number(input.value)||1)+Number(el.dataset.quantityStep)));}
    if(el.hasAttribute('data-sticky-add')){const form=$('.mw-product-form',el.closest('[data-product-section]'));if(form?.reportValidity())addProduct(form,el);}

    if(el.hasAttribute('data-cart-step')){const input=$('[data-cart-key]',el.parentElement);if(input&&!input.disabled){input.value=Math.max(0,Math.min(99,Number(input.value)+Number(el.dataset.cartStep)));updateCartQuantity(input);}}
    if(el.hasAttribute('data-cart-add')){
      el.disabled=true;const label=el.textContent;el.textContent='Adding…';
      try{await mutateCart(async()=>{await fetchJSON(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(el.dataset.cartAdd),quantity:1}]})});await refreshCart();});}
      catch(e){toast(e.message);$$('[data-cart-error]').forEach(n=>n.textContent=e.message);}
      finally{el.disabled=false;el.textContent=label;}
    }
    if(el.hasAttribute('data-cart-remove')){el.disabled=true;try{await mutateCart(async()=>refreshCart(await fetchJSON(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:el.dataset.cartRemove,quantity:0})})));}catch(e){toast(e.message);el.disabled=false;}}

    if(el.hasAttribute('data-open-fit'))window.MWFit?.open(el.closest('[data-product-section]'),el);
    if(el.hasAttribute('data-open-size'))openDialog($('[data-size-modal]',el.closest('[data-product-section]')),el);

    if(el.hasAttribute('data-zoom'))openImageZoom(el,el);
    if(el.hasAttribute('data-gallery-zoom')){const gallery=$('[data-gallery]',el.closest('.mw-gallery-wrap'));const slide=gallery.children[Math.round(gallery.scrollLeft/Math.max(1,gallery.clientWidth))];openImageZoom(slide,el);}
    if(el.hasAttribute('data-zoom-step'))stepImageZoom(Number(el.dataset.zoomStep));

    if(el.hasAttribute('data-toggle-filters')){const filters=$('.mw-filters',el.closest('form'));filters.hidden=!filters.hidden;el.setAttribute('aria-expanded',String(!filters.hidden));}

    if(el.hasAttribute('data-read-more-toggle')){const section=el.closest('.section-read-more-content'),expanded=$('[data-read-more-expanded]',section);const open=el.getAttribute('aria-expanded')!=='true';el.setAttribute('aria-expanded',String(open));expanded.hidden=!open;$('.read-more-content__wrapper',section)?.classList.toggle('is-expanded',open);}

    if(el.hasAttribute('data-gallery-step')){const gallery=$('[data-gallery]',el.closest('.mw-gallery-wrap'));gallery.scrollBy({left:gallery.clientWidth*Number(el.dataset.galleryStep),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}

    if(el.hasAttribute('data-bundle-filter')){
      const section=el.closest('[data-bundle-section]'),filter=el.dataset.bundleFilter;
      $$('[data-bundle-filter]',section).forEach(b=>b.setAttribute('aria-pressed',String(b===el)));
      const cards=$$('[data-bundle-product]',section);cards.forEach(card=>{card.hidden=filter!=='all'&&!card.dataset.bundleGender.split(/\s+/).includes(filter);});
      const count=cards.filter(card=>!card.hidden).length;$('[data-bundle-visible-count]',section).textContent=`${count} pieces`;$('[data-bundle-catalog-empty]',section).hidden=count>0;
    }

    if(el.hasAttribute('data-bundle-toggle')){
      const card=el.closest('[data-bundle-product]'),panel=$('[data-bundle-options]',card),opening=panel.hidden;
      panel.hidden=!opening;el.setAttribute('aria-expanded',String(opening));
      if(opening)$('[data-bundle-variant]',card).focus({preventScroll:true});
    }

    if(el.hasAttribute('data-bundle-add')){

      const section=el.closest('[data-bundle-section]'),card=el.closest('[data-bundle-product]'),option=$('[data-bundle-variant]',card).selectedOptions[0];

      if(section.bundleBusy||!option?.value||option.disabled)return;
      if(section.bundleItems.filter(p=>p.id===Number(option.value)).length>=Number(option.dataset.stock||section.dataset.maxItems)){toast('All available units of this option are already in your bundle.');return;}

      if(section.bundleItems.length>=Number(section.dataset.maxItems)){toast('Your bundle is full. Remove an item to add another.');return;}

      const p=JSON.parse($('[data-bundle-product-json]',card).textContent);

      section.bundleItems.push({...p,image:option.dataset.image||p.image,id:Number(option.value),price:Number(option.dataset.price),variant:option.textContent});$('[data-bundle-error]',section).textContent='';renderBundle(section);toast('Added to bundle');

    }

    if(el.hasAttribute('data-bundle-remove')){const section=el.closest('[data-bundle-section]');if(section.bundleBusy)return;section.bundleItems.splice(Number(el.dataset.bundleRemove),1);$('[data-bundle-error]',section).textContent='';renderBundle(section);}

    if(el.hasAttribute('data-bundle-submit')){

      const section=el.closest('[data-bundle-section]'),items=[...section.bundleItems];if(!items.length||section.bundleBusy)return;

      const error=$('[data-bundle-error]',section),label=el.textContent;error.textContent='';section.bundleBusy=true;renderBundle(section);el.textContent='Adding…';

      try{await mutateCart(async()=>{const grouped=new Map();items.forEach(p=>grouped.set(p.id,(grouped.get(p.id)||0)+1));await fetchJSON(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[...grouped].map(([id,quantity])=>({id,quantity,properties:{_mw_bundle:'cashmere'}}))})});section.bundleItems=[];renderBundle(section);openDialog($('#MWCart'),el);await refreshCart();});}catch(e){error.textContent=e.message;}finally{section.bundleBusy=false;el.textContent=label;renderBundle(section);}

    }

  });

  document.addEventListener('submit',event=>{const form=event.target;if(form.matches('.mw-product-form,[data-quick-form]')){event.preventDefault();addProduct(form);}});

  document.addEventListener('change',async event=>{

    const el=event.target;

    if(el.hasAttribute('data-bundle-variant')){const option=el.selectedOptions[0];if(option?.value){const price=Number(option.dataset.price),compare=Number(option.dataset.comparePrice||0);$('[data-bundle-price]',el.closest('[data-bundle-product]')).innerHTML=money(price)+(compare>price?` <s>${money(compare)}</s>`:'');}renderBundle(el.closest('[data-bundle-section]'));}

    if(el.closest('[data-option-index]'))updateVariant(el.closest('[data-product-section]'));

    if(el.hasAttribute('data-quick-option'))updateQuickVariant(el.closest('[data-quick-content]'));
    if(el.hasAttribute('data-sort'))el.form.requestSubmit();

    if(el.hasAttribute('data-cart-key'))updateCartQuantity(el);
  });

  let searchTimer,searchController;

  document.addEventListener('input',event=>{

    const input=event.target;
    if(input.hasAttribute('data-cart-key')){clearTimeout(input.mwQuantityTimer);input.mwQuantityTimer=setTimeout(()=>updateCartQuantity(input),500);return;}
    if(!input.matches('[data-predictive]'))return;
    clearTimeout(searchTimer);searchController?.abort();const result=$('[data-search-results]'),query=input.value.trim();

    if(query.length<2){result.replaceChildren();return;}

    searchTimer=setTimeout(async()=>{searchController=new AbortController();try{

      const response=await fetch(`${root}search?type=product&q=${encodeURIComponent(scopedSearch(query+'*'))}&section_id=mw-main-search`,{credentials:'same-origin',signal:searchController.signal});
      if(!response.ok)throw new Error('Unable to search');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      const cards=$$('.mw-search-page .mw-card',html).slice(0,8);
      result.innerHTML=cards.map(card=>{const link=$('.mw-card-body h3 a',card),image=$('.mw-card-primary',card),price=$('.mw-price',card);return `<a class="mw-search-result" href="${escape(link.getAttribute('href'))}"><img src="${escape(image?.getAttribute('src')||'')}" alt="${escape(link.textContent)}"><span>${escape(link.textContent)}<small>${escape(price?.textContent)}</small></span></a>`;}).join('')||'<p>No products found.</p>';
    }catch(e){if(e.name!=='AbortError')result.textContent='Search is temporarily unavailable. Press Enter to search.';}},250);

  });

  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!form.matches('.mw-search-form'))return;
    const input=$('input[name=q]',form),q=input.value.trim();if(!q)return;
    event.preventDefault();const url=new URL(form.action,location.origin);
    url.searchParams.set('type','product');url.searchParams.set('q',scopedSearch(q));location.assign(url);
  });

  document.addEventListener('keydown',event=>{if(event.key==='Escape')$$('.mw-nav-details').forEach(el=>el.open=false);if($('#MWZoom')?.open&&['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();stepImageZoom(event.key==='ArrowLeft'?-1:1);}});

  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:unload',event=>$$('.mw-desktop-nav',event.target).forEach(nav=>nav.mwNavCleanup?.()));
  document.addEventListener('shopify:section:unload',event=>$$('[data-pdp-suggestions]',event.target).forEach(section=>section.mwSuggestionsObserver?.disconnect()));
  document.addEventListener('shopify:section:unload',event=>$$('[data-product-section]',event.target).forEach(section=>section.mwStickyCleanup?.()));
  document.addEventListener('shopify:section:unload',event=>$$('[data-gallery]',event.target).forEach(gallery=>gallery.mwGalleryCleanup?.()));

  document.addEventListener('shopify:section:unload',event=>$$('[data-announcements]',event.target).forEach(el=>clearInterval(el.mwTimer)));

  document.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[role=tabpanel]');if(panel)$(`[data-tab="${panel.id}"]`)?.click();});

  const scroll=()=>document.body.classList.toggle('is-scrolled',window.scrollY>40);addEventListener('scroll',scroll,{passive:true});scroll();

  initialize();renderWishlist();

})();
